import React, { useState } from "react";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
let ClassAttendance = () => {
  let TableData = [
    {
      date: "JAN 4, 2022",
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Willow Anderson",
      noOfStudent: 100,
      country: "burnside",
      state: "burnside",
      totalHours: "5h",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudent: 88,
      country: "burnside",
      state: "burnside",
      totalHours: "5h",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudent: 75,
      country: "burnside",
      state: "burnside",
      totalHours: "6h",
      status: "Cancelled",
    },
    {
      date: "JAN 4, 2022",
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Willow Anderson",
      noOfStudent: 100,
      country: "burnside",
      state: "burnside",
      totalHours: "5h",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudent: 88,
      country: "burnside",
      state: "burnside",
      totalHours: "5h",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      title: "Lorem ipsum",
      description: "Lorem ipsum dolor...",
      tutorName: "Henry O'Brien",
      noOfStudent: 75,
      country: "burnside",
      state: "burnside",
      totalHours: "6h",
      status: "Cancelled",
    },
  ];
  return (
    <div>
      <div className="table-container">
        <div className="table-header">
          <p className="table-heading">Class Attendance</p>
        </div>
        <div className="table-data-container">
          <table>
            <thead>
            <tr>
              <th className="class-attendance-table-id-heading">ID</th>
              <th className="class-attendance-table-date-heading">Date</th>
              <th className="class-attendance-table-image-heading">Image</th>
              <th className="class-attendance-table-class-title-heading">
                Class Title
              </th>
              <th className="class-attendance-table-description-heading">
                Discription
              </th>
              <th className="class-attendance-table-tutors-name-heading">
                Tutors Name
              </th>
              <th className="class-attendance-table-student-no-heading">
                No. of Students
              </th>
              <th className="class-attendance-table-country-heading">
                Country
              </th>
              <th className="class-attendance-table-state-heading">State</th>
              <th className="class-attendance-table-total-hours-heading">
                Total Hour
              </th>
              <th className="class-attendance-table-status-heading">Status</th>
              <th className="class-attendance-table-action-heading"></th>
            </tr>
            </thead>
            <br />
            {TableData.map((tableValue, tableIndex) => {
              return (
                <tr key={tableIndex}>
                  <td className="table-id-data">{tableIndex + 1}</td>
                  <td className="table-data">{tableValue.date}</td>
                  <td>
                    <img src={ProfileImg} className="table-image" />
                  </td>
                  <td className="table-data">{tableValue.title}</td>
                  <td className="table-data">{tableValue.description}</td>
                  <td className="table-data">{tableValue.tutorName}</td>
                  <td className="class-attendance-table-data">
                    {tableValue.noOfStudent}
                  </td>
                  <td className="table-data">{tableValue.country}</td>
                  <td className="table-data">{tableValue.state}</td>
                  <td className="class-attendance-table-data">
                    {tableValue.totalHours}
                  </td>
                  <td className="table-data">
                    <div
                      className="class-attendance-table-status-card"
                      style={{
                        backgroundColor:
                          tableValue.status === "Cancelled"
                            ? "#FFB0B0"
                            : "#D2FFEB",
                        color:
                          tableValue.status === "Cancelled"
                            ? "#B80000"
                            : "#098B51",
                      }}
                    >
                      {tableValue.status}
                    </div>
                  </td>
                  <td className="table-data">
                    <select className="table-action-dropdown">
                      <option value="">Action</option>
                      <option value="View">View</option>
                    </select>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
        <div className="table-pagination-main">
          <Stack spacing={2}>
            <Pagination count={10} variant="outlined" shape="rounded" />
          </Stack>
        </div>
      </div>
    </div>
  );
};
export default ClassAttendance;
